import {
  ApiBookedItem,
  ApiBooking,
  ApiFlightItem,
  ApiHotelRoom,
  ApiItemType,
  ApiRoomRate
} from '@ibe/api';
import React, { JSX } from 'react';
import InfoContentItem from './InfoContentItem';
import FlightInfoItem from './FlightInfoItem';
import HotelContentItem from './HotelContentItem';

interface InfoContentProps {
  booking: ApiBooking;
  item: ApiBookedItem;
}

const InfoContent = (props: InfoContentProps): JSX.Element => {
  const { item, booking } = props;

  return (
    <>
      <div>
        {booking.bookedItems
          .filter(
            bookedItem =>
              bookedItem.relatedBookedItemId && bookedItem.relatedBookedItemId === item.id
          )
          .filter(
            (value, index, self) =>
              index === self.findIndex(t => t.id === value.id) ||
              value.itemType === ApiItemType.HOTEL
          )
          .map(bookedItem => {
            const unit = booking.items.find(it => it.id === bookedItem.idParent);
            const subUnit = booking.items.find(it => it.id === unit?.idParent);
            const flight =
              bookedItem.itemType === ApiItemType.FLIGHT
                ? (booking.items.find(it => it.id === bookedItem.idParent) as ApiFlightItem)
                : undefined;
            return (
              <div key={bookedItem.id}>
                <div className="d-flex justify-content-between mb-1">
                  {bookedItem.itemType === ApiItemType.FLIGHT && flight && (
                    <FlightInfoItem flight={flight} bookedItem={bookedItem} />
                  )}
                  {bookedItem.itemType === ApiItemType.HOTEL && subUnit && unit && (
                    <HotelContentItem
                      bookedItem={bookedItem}
                      room={subUnit as ApiHotelRoom}
                      rate={unit as ApiRoomRate}
                    />
                  )}
                  {bookedItem.itemType === ApiItemType.INSURANCE && unit && (
                    <InfoContentItem bookedItem={bookedItem} unit={unit} />
                  )}
                  {bookedItem.itemType === ApiItemType.TRANSFER && unit && (
                    <InfoContentItem bookedItem={bookedItem} unit={unit} />
                  )}
                  {bookedItem.itemType === ApiItemType.EXTRA && subUnit && (
                    <InfoContentItem bookedItem={bookedItem} unit={subUnit} />
                  )}
                  {bookedItem.itemType === ApiItemType.CAR && unit && (
                    <InfoContentItem bookedItem={bookedItem} unit={unit} />
                  )}
                </div>
                <hr />
              </div>
            );
          })}
      </div>
    </>
  );
};
export default InfoContent;
